export class GeofencingConstant {
  static readonly PickupTruckInZone = 3;
  static readonly PickupTruckOutOfZone = 0.5;
  static readonly PickupStoppedFor = 20;
  static readonly DropOffTruckInZone = 3;
  static readonly DropOffTruckOutOfZone = 1.5;
  static readonly DropOffStoppedFor = 5;
}
